import React from "react";
import CustomModal from "../../../../../components/ui/CustomModal/customModal";
import styles from "./RemoveVnModal.module.css";
import ApiService from "../../../../../components/apiService/ApiService";

const RemoveVnModal = ({ visible, onClose, id, accountId, handleFeedback }) => {
  //Handlers
  const removeHandler = () => {
    const payload = {
      action: "remove",
      number_ids: [id],
    };
    ApiService.post(
      `/api/v1/dashboard/update-vn-licenses/${accountId}/`,
      payload
    )
      .then((response) => {
        handleFeedback(response);
      })
      .catch((error) => handleFeedback(error?.response))
      .finally(() => onClose());
  };

  return (
    <CustomModal
      visible={visible}
      closeModal={onClose}
      bodyStyles={{ maxHeight: "75vh", padding: "0 1em" }}
      heading="Remove virtual number"
      body={
        <div className={styles.body}>
          <p>Are you sure you want to remove this virtual number add-on?</p>
          <p>Please note:</p>
          <ul>
            <li>
              The number will be released from the organization immediately.
            </li>

            <li>The virtual number add-on license will be deleted.</li>

            <li>The changes will be updated in Zoho Billing right away.</li>
          </ul>
          <div className={styles.separator} />
          <div className={styles.footerContainer}>
            <button onClick={onClose} className={styles.secondaryButton}>
              Cancel
            </button>
            <button onClick={removeHandler} className={styles.dangerButton}>
              Yes, remove
            </button>
          </div>
        </div>
      }
    />
  );
};

export default RemoveVnModal;
